@for (position of positions; track position) {
    <div class="fixed z-[1001]" [class]="getPositionClasses(position)">
        <div class="flex flex-col">
            @for (toast of getToastsByPosition(position); track toast.id) {
                <div
                    [@toastAnimation]="{
                        value: 'active',
                        params: {
                            transform: getTransform(position),
                        },
                    }"
                >
                    <pax-toast [toast]="toast" (closeToast)="removeToast($event)"></pax-toast>
                </div>
            }
        </div>
    </div>
}
